export default {"src":"/_next/static/media/scope_logo_rgb_black.f7023dcc.svg","height":71,"width":304,"blurWidth":0,"blurHeight":0};